export const SDK_VERSION = '3.0.1' as const;
